export default __webpack_public_path__ + "static/media/add_note.0b14af77.png";